/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

module.exports = {
  TOPIC_INFO_IMGS(state, list) {
    state.topicInfoImgs = list;
  }
}



// WEBPACK FOOTER //
// ./src/appBackend/vuex/mutation/topicInfoImgs.js